(function () {
  // @ts-ignore
  function initDropdown(wrapper) {
    var trigger = wrapper.querySelector('[data-country-trigger]');
    var panel = wrapper.querySelector('[data-country-panel]');
    var nativeSelect = wrapper.querySelector('select');
    var flagImg = wrapper.querySelector('[data-country-flag-img]');
    var options = wrapper.querySelectorAll('[data-country-option]');

    if (!trigger || !panel || !nativeSelect || !options.length) return;

    // @ts-ignore
    function setFlag(optionEl) {
      var flag = optionEl.getAttribute('data-flag');
      if (flag) {
        flagImg.src = flag;
        flagImg.alt = optionEl.getAttribute('data-label') || '';
        flagImg.style.display = '';
      } else {
        flagImg.removeAttribute('src');
        flagImg.style.display = 'none';
      }
    }

    // @ts-ignore
    function selectOption(optionEl, opts) {
      opts = opts || {};
      var value = optionEl.getAttribute('data-value');

      setFlag(optionEl);

      // @ts-ignore
      options.forEach(function (o) {
        o.setAttribute('aria-selected', o === optionEl ? 'true' : 'false');
      });

      if (nativeSelect.value !== value) {
        nativeSelect.value = value;
        if (!opts.silent) {
          nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    function openPanel() {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }

    function closePanel() {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }

    // @ts-ignore
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      panel.hidden ? openPanel() : closePanel();
    });

    // @ts-ignore
    options.forEach(function (optionEl) {
      optionEl.addEventListener('click', function () {
        selectOption(optionEl);
        closePanel();
      });
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) closePanel();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });

    // Initialize the flag to match whichever option is selected by default
    // (login.js's own wireCountryPhoneSync already set the text label).
    var initial =
      Array.prototype.find.call(options, function (o) {
        return o.getAttribute('data-value') === nativeSelect.value;
      }) || options[0];

    if (initial) selectOption(initial, { silent: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-country-dropdown]').forEach(initDropdown);
  });
})();